import { render } from "./DashboardSkeleton.vue?vue&type=template&id=0d475892"
import script from "./DashboardSkeleton.vue?vue&type=script&lang=js"
export * from "./DashboardSkeleton.vue?vue&type=script&lang=js"

import "./DashboardSkeleton.vue?vue&type=style&index=0&id=0d475892&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/DashboardSkeleton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d475892"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d475892', __exports__)) {
    console.log('reload')
    api.reload('0d475892', __exports__)
  }
  
  module.hot.accept("./DashboardSkeleton.vue?vue&type=template&id=0d475892", () => {
    console.log('re-render')
    api.rerender('0d475892', render)
  })

}


export default __exports__